import React from 'react';

export function SuggestedTime(props){
    return ( 
        <span  className="badge customized-badge rounded-border even-larger-badge " >Suggested time: {props.time} minutes</span>
    )
      
      
}